import { render, staticRenderFns } from "./kpi-rating-metric-field.vue?vue&type=template&id=6b3a1966&"
import script from "./kpi-rating-metric-field.vue?vue&type=script&lang=js&"
export * from "./kpi-rating-metric-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports